import { CalendarBlockWrapper } from './components'
import type { MouseEventHandler } from 'react'

interface CalendarBlockProps {
  background: string
  width?: number
  left?: number
  starting: boolean
  ending: boolean
  text: string
  onClick?: MouseEventHandler<HTMLDivElement>
}

export const CalendarBlock: React.FC<CalendarBlockProps> = ({
  background,
  starting,
  width,
  left,
  ending,
  text,
  onClick,
}) => {
  return (
    <CalendarBlockWrapper
      background={background}
      width={width?.toString()}
      left={left?.toString()}
      new={starting}
      ending={ending}
      onClick={onClick}
      title={text}
    >
      {text}
    </CalendarBlockWrapper>
  )
}
